export default {
    createMetaDescription(title, description) {
        document.title = title;

          // Verifica si ya existe un meta con el nombre "description"
        let existingMetaDescription = document.querySelector('meta[name="description"]');

        // Si no existe, crea un nuevo elemento meta y configura sus atributos
        if (!existingMetaDescription) {
            let newMetaDescription = document.createElement('meta');
            newMetaDescription.setAttribute('name', 'description');
            newMetaDescription.setAttribute('itemprop', 'description');
            newMetaDescription.setAttribute('content', description);
        
            // Agrega el nuevo meta al head de la página
            document.head.appendChild(newMetaDescription);
        } else {
            existingMetaDescription.setAttribute('content', description);
        }

         // Agregar etiqueta og:title
        let existingOgTitle = document.querySelector('meta[property="og:title"]');
        if (!existingOgTitle) {
        let newOgTitle = document.createElement('meta');
        newOgTitle.setAttribute('property', 'og:title');
        newOgTitle.setAttribute('content', title);
        document.head.appendChild(newOgTitle);
        } else {
        existingOgTitle.setAttribute('content', title);
        }

        // Agregar etiqueta og:description
        let existingOgDescription = document.querySelector('meta[property="og:description"]');
        if (!existingOgDescription) {
        let newOgDescription = document.createElement('meta');
        newOgDescription.setAttribute('property', 'og:description');
        newOgDescription.setAttribute('content', description);
        document.head.appendChild(newOgDescription);
        } else {
        existingOgDescription.setAttribute('content', description);
        }

        // Agregar etiqueta og:image
        let imageUrl = '/assets/images/layout/AD_Logo/PNG/AutoDeal_Logo_Digital.png';
        let existingOgImage = document.querySelector('meta[property="og:image"]');
        if (!existingOgImage) {
        let newOgImage = document.createElement('meta');
        newOgImage.setAttribute('property', 'og:image');
        newOgImage.setAttribute('content', imageUrl);
        document.head.appendChild(newOgImage);
        } else {
        existingOgImage.setAttribute('content', imageUrl);
        }
    }
  };